import axios from 'axios'
import reqBase from '@/_helpers/requests/reqBase'

const requestBlob = axios.create({
    responseType: 'arraybuffer'
})

requestBlob.interceptors.request.use(
    config => reqBase.interceptorsRequest(config))

requestBlob.interceptors.response.use(function (response) {

    return response;
}, function (error) {

    let _response = error.response;

    _response.data = _response.headers['error-message']
    _response['type'] = 'Error';
    reqBase.interceptorsResponse(_response);

    return Promise.reject(error);
});
  
export default requestBlob